module.exports = __webpack_public_path__ + "static/media/puertoMaldonado.2e23d06d.jpg";